import React, { useEffect, useState } from "react";
import {
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from "reactstrap";
import { operationService } from "../../../../../services";
import Select from "react-select";

const Index = ({ id, name, handleUpdate, editmodal, setEditModal,editSuggestedName,suggestedSets,setEditSuggestedName }) => {
    const [updatedName, setUpdatedName] = useState(name);
    const [editError, setEditError] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedSuggestedSets,setSelectedSuggestedSets] = useState([]);
    const [addSuggestedSets,setAddSuggestedSets] = useState([]);

    const toggleEditModal = () => {
        setEditSuggestedName([]);
        setSelectedSuggestedSets([]);
        setAddSuggestedSets([]);
        setEditModal(!editmodal);
        setEditError("");
    };

    const handleNameChange = (e) => {
        setUpdatedName(e.target.value);
    };

    const handleUpdateSubmit = () => {
        setLoading(true);
        operationService
            .update({ id: id, name: updatedName,suggestedSets:addSuggestedSets })
            .then((res) => {
                console.log(res);
                console.log("Item updated successfully");
                handleUpdate(id, updatedName,selectedSuggestedSets);
                toggleEditModal();
            })
            .catch((error) => {
                console.log("Error updating item:", error);
                setEditError(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    useEffect(() => {
        setUpdatedName(name);
    }, [name]);

    useEffect(() => {
        if(editSuggestedName?.length){
            var tempSuggestedSets = [];
            var tempSuggestedSetsValue = [];
            editSuggestedName.map(item => {
                let obj = {
                    label : item.sets[0]?.set_name,
                    value : item.sets[0]?._id,
                    sets: [{set_name:item?.sets[0]?.set_name,_id:item?.sets[0]?._id}]
                };
                tempSuggestedSets.push(item?.sets[0]?._id);
                tempSuggestedSetsValue.push(obj);
            });
    
            setAddSuggestedSets(tempSuggestedSets);
            setSelectedSuggestedSets(tempSuggestedSetsValue);
        }
    }, [editSuggestedName]);

    const setSelectedOptionSuggestedSets = selectedSuggestedSets => {
        var tempSuggestedSets = [];
        selectedSuggestedSets.map(item => {
            tempSuggestedSets.push(item.value);
            item.sets = [{set_name:item.label,_id:item.value}];
        });
        setAddSuggestedSets(tempSuggestedSets);
        setSelectedSuggestedSets(selectedSuggestedSets);
    };

    return (
        <>
            <div>
                <Modal
                    size="md"
                    backdrop="static"
                    isOpen={editmodal}
                    toggle={toggleEditModal}
                >
                    <ModalHeader className="" toggle={toggleEditModal}>
                        Edit Operation
                    </ModalHeader>
                    <ModalBody>
                        <form className="">
                            <div className="form-group row">
                                <div className="col">
                                    <label>Operation Name</label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        value={updatedName}
                                        onChange={handleNameChange}
                                    />
                                    {editError && editError.name && (
                                        <span className="text-danger">
                                            {editError.name}
                                        </span>
                                    )}
                                    {editError && editError.common && (
                                        <span className="text-danger">
                                            {editError.common}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Add Suggested sets{" "}
                                </label>
                                <Select
                                    value={selectedSuggestedSets}
                                    onChange={setSelectedOptionSuggestedSets}
                                    options={suggestedSets}
                                    isMulti={true}
                                />
                            </div>

                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div className="">
                            <button
                                onClick={toggleEditModal}
                                className="btn btn-secondary mr-2"
                                data-dismiss="modal"
                            >
                                Cancel
                            </button>

                            {loading ? (
                                <button
                                    style={{minHeight:"37px"}}
                                    className="btn btn-primary loader-icon"
                                    disabled
                                >
                                    <Spinner className="img-svg"></Spinner>
                                </button>
                            ) : (
                                <button
                                    className="btn btn-primary"
                                    onClick={handleUpdateSubmit}
                                >
                                    Update
                                </button>
                            )}
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        </>
    );
};

export default Index;
